import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  EditSaleCart,
  clearError,
  clearMessage,
} from "../redux/saleSlice";

const EditSaleModel = ({ visible, onCancel, product }) => {
  const dispatch = useDispatch();
  const [manual_price, setManual_price] = useState(product.manual_price);
  const [pack, setPack] = useState(product.pack);
  const [units, setUnits] = useState(product.units);
    const [prodcut_price, setProdcut_price] = useState();
  const { loading, error, message } = useSelector((state) => state.sales);

  const confirmSellProduct = () => {
    const saleData = {
      id: product.id,
      manual_price,
      pack,
      units,
      prodcut_price
    };
    dispatch(EditSaleCart(saleData));
    onCancel();
  };

  useEffect(() => {
    if (pack > product.packStock) {
      alert(`only ${product.packStock} packs left`);
    } 
    setProdcut_price(pack * product.sellingPricePack + units * product.sellingPriceUnit);
  }, [ product.packStock, pack, units, product.sellingPricePack, product.sellingPriceUnit]);

  useEffect(() => {
    if (error) {
      alert(error);
      dispatch(clearError());
    }
    if (message) {
      alert(message);
      dispatch(clearMessage());
    }
  }, [error, dispatch, message]);

  return visible ? (
    <div className="fixed inset-0 flex justify-center items-center bg-black/50 z-50">
      <div className="bg-white p-6 rounded-lg w-1/3">
        <div className="text-center">
          <h2 className="text-lg font-semibold">Sale {product.product_name}</h2>
          <p className="text-gray-600 mt-2">Enter Units and Packs</p>
          <p className="text-gray-600 mt-2">
            Stock: {product.packStock}.{product.unitStock} qty
          </p>
        </div>

        <div className="flex justify-between gap-2 mt-4">
          <div className="flex-1">
            <label className="text-gray-700 mt-4 block">Pack</label>
            <input
              type="number"
              value={pack?.toString()}
              onChange={(e) => setPack(Number(e.target.value))}
              placeholder="Enter pack"
              className="border p-2 w-full rounded-full mt-2"
            />
          </div>
          <div className="flex-1">
            <label className="text-gray-700 mt-4 block">Units</label>
            <input
              type="number"
              value={units?.toString()}
              onChange={(e) => setUnits(Number(e.target.value))}
              placeholder="Enter units"
              className="border p-2 w-full rounded-full mt-2"
            />
          </div>
        </div>

        <div className="mt-4">
          <label className="text-gray-700 block">Manual Price</label>
          <input
            type="number"
            value={manual_price?.toString()}
            onChange={(e) => setManual_price(Number(e.target.value))}
            placeholder="Enter manual price"
            className="border p-2 w-full rounded-full mt-2"
          />
        </div>

        <div className="flex justify-center mt-8">
          <button
            onClick={onCancel}
            className="px-6 py-2 bg-gray-300 rounded-lg mr-4"
          >
            Cancel
          </button>
          <button
            onClick={confirmSellProduct}
            className="px-6 py-2 bg-indigo-600 rounded-lg text-white"
          >
            {loading ? "...Loading" : "Confirm"}
          </button>
        </div>
      </div>
    </div>
  ) : null;
};

export default EditSaleModel;
